export const DEFAULT_EXPORT_MAX_PROPERTIES = 10000;

export function addUniquePropertyIds(selectedIds, incomingIds, limit) {
  const ids = new Set(selectedIds);

  incomingIds.forEach((id) => ids.add(id));

  if (ids.size > limit) {
    return { ids: selectedIds, exceeded: true };
  }

  return { ids: Array.from(ids), exceeded: false };
}

export function mergePropertyIds(selectedIds, incomingIds, limit) {
  const ids = [...selectedIds];
  const seen = new Set(selectedIds);
  let addedCount = 0;
  let capped = false;

  incomingIds.forEach((id) => {
    if (typeof id !== "string" || id.trim() === "" || seen.has(id)) {
      return;
    }

    if (ids.length >= limit) {
      capped = true;
      return;
    }

    seen.add(id);
    ids.push(id);
    addedCount += 1;
  });

  return { ids, addedCount, capped };
}
